export default __webpack_public_path__ + "static/media/education.b669ac8a.jpg";